import React, { ReactElement, FC } from 'react'
import './style.scss'
import { HeaderFields } from 'types/headerFields'
import { CheckedIcon } from 'components/icons/checkedIcon'
export const Header: FC<HeaderFields> = ({
  title,
  description,
  doneMunicipalCouncil,
  countStatus
}): ReactElement => {
  return (
    <div className='header-wrapper'>
      <h3 className='ui header'>{title}</h3>
      {description && <p className='description'> {description}</p>}
      {/* {doneMunicipalCouncil && (
        <p className='status'>
          Schlussresultat <CheckedIcon />
        </p>
      )} */}
      {countStatus && doneMunicipalCouncil === false && (
        <p className='status'> {countStatus}</p>
      )}
    </div>
  )
}
